import { v4 as uuidv4 } from 'uuid';
import { PaletteBoxCreatePluginSettings } from './PaletteBoxCreatePluginSettings'
import ScanBoxView from './ScanBoxView';

export const PaletteBoxTabTitle = 'Палета';

export const PaletteBoxTab = (): ITab => {
    return {
        id: uuidv4(),
        title: PaletteBoxTabTitle,
        view: {
            content: PaletteBoxCreatePluginSettings
                ? <ScanBoxView gridId={uuidv4()} plugin={PaletteBoxCreatePluginSettings} isPalette />
                : <p> Справочник не настроен </p>
        }
    }
}

export default PaletteBoxTab
